import { Injectable } from '@angular/core';
import { Identifiable } from '../interfaces/identifiable';
import { AbstractBaseEntityApiService } from './abstract-base-entity-api.service';

@Injectable({
  providedIn: 'root',
})
export class ConfBaseEntityApiService<
  T extends Identifiable,
> extends AbstractBaseEntityApiService<T> {
  /**
   * Map base url to conf url
   * **/
  override readonly baseUrl = this.confUrl;
}
